import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  MenuItem,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const HelpPage1 = () => {
  const { accessToken } = useAuth();
  const { userData } = useOutletContext();
  const baseURL = process.env.REACT_APP_BASEURL;

  const navigate = useNavigate();

  const [sites, setSites] = useState([]);
  const [faqs, setFaqs] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    email: userData?.email || "",
    site: "",
    issue: "",
    message: "",
  });

  const [feedback, setFeedback] = useState({
    open: false,
    type: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const issueTypes = [
    "Data Issue",
    "Device not updating",
    "Sensor reading incorrect",
    "Water Balance mismatch",
    "Other",
  ];

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const res = await axios.get(`${baseURL}/faq`, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });

        setFaqs(res.data || []);
      } catch (err) {
        console.error("Failed to load FAQs", err);
      }
    };

    if (accessToken) fetchFaqs();
  }, [accessToken, baseURL]);

  // Fetch sites from backend
  useEffect(() => {
    const fetchSites = async () => {
      try {
        const res = await axios.get(`${baseURL}/get-sites`, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });

        const allSites = res.data.data || [];
        console.log("Alls sites", allSites);

        // Filter only the sites this user has access to
        const filtered = allSites.filter(
          (s) =>
            userData?.sites?.includes(s.id.toString()) ||
            userData?.sites?.includes(s.id)
        );

        setSites(filtered);
      } catch (err) {
        console.error("Failed to load sites:", err);
      }
    };

    if (accessToken) fetchSites();
  }, [accessToken, baseURL, userData]);

  useEffect(() => {
    if (userData?.email) {
      setFormData((prev) => ({ ...prev, email: userData.email }));
    }
  }, [userData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.name ||
      !formData.site ||
      !formData.issue ||
      !formData.message
    ) {
      setFeedback({
        open: true,
        type: "error",
        message: "Please fill all required fields.",
      });
      return;
    }

    setLoading(true);

    try {
      await axios.post(
        `${baseURL}/help/submit`,
        {
          ...formData,
          site: formData.site,
        },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );

      setFeedback({
        open: true,
        type: "success",
        message: "Your issue has been submitted successfully!",
      });

      setFormData({
        name: "",
        email: userData?.email || "",
        site: "",
        issue: "",
        message: "",
      });
    } catch (err) {
      setFeedback({
        open: true,
        type: "error",
        message: "Failed to submit your request.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 800, mx: "auto", mt: 4 }}>
      <Typography variant="h4" fontWeight="bold" sx={{ mb: 2 }}>
        Help & Support
      </Typography>

      {/* FAQ Section */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
            <Typography variant="h6" fontWeight="bold">
              Frequently Asked Questions
            </Typography>

            {(userData?.is_admin) && (
              <Button
                variant="contained"
                onClick={() => navigate("/dashboard/faq")}
              >
                Manage FAQ
              </Button>
            )}
          </Box>

          {faqs.map((f) => (
            <Accordion key={f._id}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography fontWeight={400}>{f.question}</Typography>
              </AccordionSummary>

              <AccordionDetails>
                <Typography fontWeight={400} fontSize={14}>
                  {f.answer}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </CardContent>
      </Card>

      {/* Support Form */}
      {/* <Card>
        <CardContent>
          <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
            Submit a Support Request
          </Typography>

          <form onSubmit={handleSubmit}>
            <TextField
              label="Your Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              fullWidth
              margin="normal"
              required
            />

            <TextField
              label="Email"
              name="email"
              value={formData.email}
              disabled
              fullWidth
              margin="normal"
            />

            <TextField
              select
              label="Select Site"
              name="site"
              value={formData.site}
              onChange={handleChange}
              fullWidth
              margin="normal"
              required
            >
              {sites.map((site) => (
                <MenuItem key={site.id} value={site.id}>
                  {site.name} ({site.id})
                </MenuItem>
              ))}
            </TextField>

            <TextField
              select
              label="Select Issue"
              name="issue"
              value={formData.issue}
              onChange={handleChange}
              fullWidth
              margin="normal"
              required
            >
              {issueTypes.map((type, i) => (
                <MenuItem key={i} value={type}>
                  {type}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              label="Your Message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              fullWidth
              margin="normal"
              multiline
              rows={4}
              required
            />

            <Box sx={{ textAlign: "right", mt: 2 }}>
              <Button type="submit" variant="contained" disabled={loading}>
                {loading ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          </form>
        </CardContent>
      </Card> */}

      {/* Snackbar */}
      <Snackbar
        open={feedback.open}
        autoHideDuration={3000}
        onClose={() => setFeedback({ ...feedback, open: false })}
      >
        <Alert severity={feedback.type}>{feedback.message}</Alert>
      </Snackbar>
    </Box>
  );
};

export default HelpPage1;
